<template>
  <div class="product" style="height: 0px;">
    <el-form class="form" label-width="auto">
      <el-form-item>
        <el-text style="margin-right: 20px; font-size: larger; font-weight: bolder;">
          <template v-if="!data.product.id">
            {{ util.language('新增', 'New ') }}
          </template>
          <template v-else>
            {{ util.language('编辑', 'Edit ') }}
          </template>
          {{ util.language('信息', 'Product') }}
        </el-text>
        <el-button-group>
          <el-button @click="router.go(-1)">{{ util.language('返回', 'Back') }}</el-button>
          <el-button type="primary" @click="save()" :loading="loading.save">{{ util.language('保存', 'Save') }}</el-button>
        </el-button-group>
      </el-form-item>
      <el-form-item label="ID" v-if="data.product.id">
        <el-input v-model="data.product.id" disabled />
      </el-form-item>
      <el-form-item label="姓名">
        <el-input v-model="data.product.name" />
      </el-form-item>
      <el-form-item label="系列名称">
        <el-input v-model="data.product.seriesName" />
      </el-form-item>
      <el-form-item label="性别">
        <el-input v-model="data.product.sex" />
      </el-form-item>
      <el-form-item label="专业名称">
        <el-input v-model="data.product.majorName" />
      </el-form-item>
      <el-form-item label="籍贯">
        <el-input v-model="data.product.nativePlace" />
      </el-form-item>
      <el-form-item label="资格名称">
        <el-input v-model="data.product.qualificationName" />
      </el-form-item>
      <el-form-item label="出生日期">
        <el-input v-model="data.product.birthDate" />
      </el-form-item>
      <el-form-item label="批准日期">
        <el-input v-model="data.product.approveDate" />
      </el-form-item>
      <el-form-item label="发证单位">
        <el-input v-model="data.product.issueUnit" />
      </el-form-item>
      <el-form-item label="发证日期">
        <el-input v-model="data.product.issueDate" />
      </el-form-item>
      <el-form-item label="网址">
        <el-input v-model="data.product.netHost" />
      </el-form-item>
      <el-form-item label="身份证号">
        <el-input v-model="data.product.idCard" />
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model="data.product.remark" />
      </el-form-item>
      <el-form-item label="证书编号">
        <el-input v-model="data.product.certificateNumber" />
      </el-form-item>
    </el-form>
    <div style="height: 10px;"></div>
  </div>
</template>

<script setup>
import { reactive, } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import api from '../../apis/api'
import cache from '../../utils/cache'
import util from '../../utils/util'
import math from '../../utils/math'

const router = useRouter()
const show = reactive({
})
const loading = reactive({
  save: false,
})
const pageParam = cache.getObject(cache.keys.pageParam + "product")
const data = reactive({
  product: pageParam ? JSON.parse(JSON.stringify(pageParam)) : {},
})

const save = () => {
  loading.save = true
  const product = {
    name: data.product.name || '',
    seriesName: data.product.seriesName || '',
    sex: data.product.sex || '',
    majorName: data.product.majorName || '',
    nativePlace: data.product.nativePlace || '',
    qualificationName: data.product.qualificationName || '',
    birthDate: data.product.birthDate || '',
    approveDate: data.product.approveDate || '',
    issueUnit: data.product.issueUnit || '',
    issueDate: data.product.issueDate || '',
    netHost: data.product.netHost || '',
    idCard: data.product.idCard || '',
    remark: data.product.remark || '',
    certificateNumber: data.product.certificateNumber || '',
  }
  if (!data.product.id) {
    api.post('/backend/product/addProduct', {
      product: product,
    }).then(() => {
      ElMessage.success(util.language('保存成功', 'success'))
      router.go(-1)
    }).finally(() => {
      loading.save = false
    })
  } else {
    product.id = data.product.id
    api.post('/backend/product/setProduct', {
      product: product,
    }).then(() => {
      ElMessage.success(util.language('保存成功', 'success'))
      router.go(-1)
    }).finally(() => {
      loading.save = false
    })
  }
}
</script>

<style lang="less">
.product {
  margin: auto;
  max-width: 900px;
}
</style>